import { ApolloClient, ApolloQueryResult, NetworkStatus } from '@apollo/client';
import { BrandCode } from 'types';
import {
	BestPromotionForMarketDocument,
	BestPromotionForMarketQuery,
	BestPromotionForMarketQueryVariables,
	PromotionsDocument,
	PromotionsQuery,
	PromotionsQueryVariables,
	TargetedOffersDocument,
	TargetedOffersQuery,
	TargetedOffersQueryVariables,
} from '../codegen/gateway/graphql';
import { GraphClientName, GraphServer } from '../constants';
import { executeQueryIgnoreError } from '../utils';

export * from '../codegen/gateway';
export * from '../codegen/gateway/graphql';

export const getBestPromoForMarket = async <TCacheShape>(
	apolloClient: ApolloClient<TCacheShape>,
	variables: BestPromotionForMarketQueryVariables,
): Promise<ApolloQueryResult<BestPromotionForMarketQuery>> => {
	return executeQueryIgnoreError(apolloClient, GraphServer.CAMPAIGNS, BestPromotionForMarketDocument, variables);
};

export const getTargetedOffers = async <TCacheShape>(
	apolloClient: ApolloClient<TCacheShape>,
	variables: TargetedOffersQueryVariables & { brand: BrandCode; initialLoad?: boolean },
): Promise<ApolloQueryResult<TargetedOffersQuery> & { networkError?: boolean }> => {
	const { brand, initialLoad = true, ...otherVariables } = variables;
	try {
		return await executeQueryIgnoreError(apolloClient, GraphServer.CAMPAIGNS, TargetedOffersDocument, otherVariables, {
			headers: {
				'apollographql-client-name': initialLoad ? GraphClientName.INITIAL_LOAD[brand] : GraphClientName.MY_OFFERS[brand],
			},
		});
	} catch (e) {
		// eslint-disable-next-line no-console
		console.log(e);
		return { data: null, loading: false, networkError: true, networkStatus: NetworkStatus.error };
	}
};

export const getPromotions = async <TCacheShape>(
	apolloClient: ApolloClient<TCacheShape>,
	variables: PromotionsQueryVariables & { currency: string },
): Promise<ApolloQueryResult<PromotionsQuery>> => {
	const { currency, ...otherVariables } = variables;
	return executeQueryIgnoreError(apolloClient, GraphServer.CAMPAIGNS, PromotionsDocument, otherVariables, {
		headers: {
			currency,
		},
	});
};
